import { render } from "./deny.vue?vue&type=template&id=39a2777c"
import script from "./deny.vue?vue&type=script&lang=js"
export * from "./deny.vue?vue&type=script&lang=js"

import "./deny.vue?vue&type=style&index=0&id=39a2777c&lang=less"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__